<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-image-filter-hdr"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1 mt-2">
        <v-col cols="8" class="white p-5 ">
          <v-col cols="12">
            <div class="mb-2 primary--text">Name<span class="necessary">(*)</span></div>
            <v-text-field
                v-model="bundleDetail.name"
                placeholder="Enter name"
                filled
            ></v-text-field>
          </v-col>
          <v-col  cols="12">
            <div class="mb-2 primary--text">Templates<span class="necessary">(*)</span></div>
            <v-select
                v-model="list_templates_id"
                :items="list_templates"
                item-text="name"
                item-value="id"
                filled
                placeholder="Choose template"
                chips
                multiple
            ></v-select>
          </v-col>
          <v-col cols="12">
            <div class="mb-2 primary--text">Credit<span class="necessary">(*)</span></div>
            <v-text-field
                v-model="bundleDetail.credit"
                placeholder="Enter credit"
                filled
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="mb-2 primary--text">Description<span class="necessary">(*)</span></div>
            <v-text-field
                v-model="bundleDetail.description"
                placeholder="Enter description"
                filled
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="mb-2 primary--text">Upload image<span class="necessary">(*)</span></div>
            <v-file-input
                filled
                prepend-icon="mdi-camera"
                v-model="image"
                @change="uploadImg"
            ></v-file-input>
            <div v-if="src" class="mb-5">
              <v-img
                  :src="src"
                  aspect-ratio="1.7"
                  contain
                  class="mx-auto"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" class="text-center mb-5 mt-1">
            <v-btn
                class="btn-add-templates"
                @click="update"
            >
              Update Bundle
            </v-btn>
          </v-col>
        </v-col>

      </v-row>
    </v-container>
  </div>
</template>

<script>
import {GET_DETAIL_BUNDLE, UPDATE_BUNDLE} from "@/store/modules/bundle";
import {mapGetters} from "vuex";
import {GET_LIST_TEMPLATE} from "@/store/modules/template";


export default {
  name: "EditBundle",
  data() {
    return {
      page: "Edit Bundle",
      breadcrumbs: [
        {
          text: "Templates Setting",
          disabled: true,
        },
        {
          text: "Bundle",
          disabled: false,
          href: '/template_setting/bundle'
        },
        {
          text: "Edit Bundle",
          disabled: false,
        },
      ],
      src: '', image: null,
      list_templates: [],
      list_templates_id: [],
    }
  },
  computed: {
    ...mapGetters({
      bundleDetail: "bundleDetail",
      templates: "templates",
    })
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(`${GET_DETAIL_BUNDLE}`, this.$route.params.id);
    await this.$store.dispatch(GET_LIST_TEMPLATE);
    if (this.bundleDetail && this.bundleDetail.templates) {
      this.bundleDetail.templates.forEach((el) => {
        this.list_templates_id.push(el.pivot.template_id);
      });
    }

  },
  watch: {
    bundleDetail(val) {
      if (val && val.img_url) {
        this.src = this.url + val.img_url
      }
    },
    templates(val) {
      if (val) {
        const _this = this
        val.forEach(el => {
          _this.list_templates.push({
            id: el.id,
            name: el.name,
          })
        })
      }
    },
  },
  methods: {
    uploadImg(e) {
      if (e) {
        this.src = URL.createObjectURL(e)
      }
      this.$forceUpdate()
    },
    async update() {
      this.bundleDetail.templates = []
      const _this = this;
      this.list_templates_id.forEach(id => {
        let tag = this.list_templates.find(el => el.id == id)
        _this.bundleDetail.templates.push(tag.id
        )
      })
      let form = new FormData();
      form.append("name", this.bundleDetail.name);
      form.append("templates", JSON.stringify(this.bundleDetail.templates));
      form.append("credit", this.bundleDetail.credit);
      form.append("description", this.bundleDetail.description);
      form.append("upload", this.image);
      const data1 = {
        data: form,
        id: this.$route.params.id
      }
      await this.$store.dispatch(`${UPDATE_BUNDLE}`, data1).then((data) => {
            if (data.data.status == 1) {
              this.$toasted.success('Update successful!', {
                duration: 1000,
                position: 'top-center'
              })
              this.$router.push('/template_setting/bundle')
            } else {
              alert(data.data.errors)
            }
          }
      )
      ;
    }
  }
}
</script>

<style scoped>
.btn-add-templates {
  background-color: #71BEC8 !important;
  color: white !important;
  border-radius: 36px !important;
}
.necessary {
  color: red;
}

</style>